import { Rocket, Zap, CreditCard, Wrench } from "lucide-react";

export function QuickLinks() {
  const links = [
    {
      icon: Rocket,
      title: "Getting Started",
      description: "Setup guides and onboarding tutorials",
      color: "blue",
      hoverBorder: "hover:border-blue-400",
      iconBg: "bg-blue-100",
      iconBgHover: "group-hover:bg-blue-600",
      iconColor: "text-blue-600",
      iconColorHover: "group-hover:text-white",
    },
    {
      icon: Zap,
      title: "Integrations",
      description: "Connect WhatsApp, Telegram, and more",
      color: "purple",
      hoverBorder: "hover:border-purple-400",
      iconBg: "bg-purple-100",
      iconBgHover: "group-hover:bg-purple-600",
      iconColor: "text-purple-600",
      iconColorHover: "group-hover:text-white",
    },
    {
      icon: CreditCard,
      title: "Billing & Plans",
      description: "Pricing, payments, and subscriptions",
      color: "green",
      hoverBorder: "hover:border-green-400",
      iconBg: "bg-green-100",
      iconBgHover: "group-hover:bg-green-600",
      iconColor: "text-green-600",
      iconColorHover: "group-hover:text-white",
    },
    {
      icon: Wrench,
      title: "Troubleshooting",
      description: "Common issues and solutions",
      color: "red",
      hoverBorder: "hover:border-red-400",
      iconBg: "bg-red-100",
      iconBgHover: "group-hover:bg-red-600",
      iconColor: "text-red-600",
      iconColorHover: "group-hover:text-white",
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-6 mb-12">
      {links.map((link) => {
        const Icon = link.icon;
        return (
          <button
            key={link.title}
            className={`
              group
              bg-white
              border border-gray-200
              rounded-xl
              p-6
              text-left
              hover:shadow-lg
              ${link.hoverBorder}
              transition-all
            `}
          >
            <div
              className={`
                w-12 h-12 rounded-lg ${link.iconBg} ${link.iconBgHover}
                flex items-center justify-center mb-4 transition-colors
              `}
            >
              <Icon className={`w-6 h-6 ${link.iconColor} ${link.iconColorHover} transition-colors`} />
            </div>
            <h3 className="text-base font-semibold text-gray-900 mb-2">{link.title}</h3>
            <p className="text-sm text-gray-600">{link.description}</p>
          </button>
        );
      })}
    </div>
  );
}
